import { combineReducers } from 'redux';
import list from './list';
import create from './create';
import update from './update';
import del from './delete';
import show from './show';
import register from './register';
import forSelect from './forSelect';
import currentCompany from './currentCompany';
import activate from './activate';
import deactivate from './deactivate';

export default combineReducers({ list, create, update, del, show, register, forSelect, currentCompany, activate, deactivate });
